/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Realitni_TrhInputs */

const cs_enum_realitni_trh = /** @type {(inputs: Enum_Realitni_TrhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realitní trh`)
};

const en_enum_realitni_trh = /** @type {(inputs: Enum_Realitni_TrhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realitní trh`)
};

/**
* | output |
* | --- |
* | "Realitní trh" |
*
* @param {Enum_Realitni_TrhInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_realitni_trh = /** @type {((inputs?: Enum_Realitni_TrhInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Realitni_TrhInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_realitni_trh(inputs)
	return cs_enum_realitni_trh(inputs)
});